import { render, staticRenderFns } from "./conference_modal.vue?vue&type=template&id=0b5b870b&scoped=true&"
import script from "./conference_modal.vue?vue&type=script&lang=js&"
export * from "./conference_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b870b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5b870b')) {
      api.createRecord('0b5b870b', component.options)
    } else {
      api.reload('0b5b870b', component.options)
    }
    module.hot.accept("./conference_modal.vue?vue&type=template&id=0b5b870b&scoped=true&", function () {
      api.rerender('0b5b870b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/conference/conference_modal/conference_modal.vue"
export default component.exports